// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
/**
 * Converts a given pixel value into a string representation of a rem value.
 *
 * @param px - A number representing a pixel value to convert.
 * @param base - An optional parameter representing the base pixel size to use for conversion. If one is not
 * specified, 16 is used by default
 * @returns A string representation of a rem value (i.e. 2rem)
 * @throws Throws an error if zero is provided as the base value
 */ export var rem = function(px) {
    var base = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 16;
    if (base === 0) {
        throw new Error('Base pixel value cannot be zero');
    }
    return "".concat(px / base, "rem");
};
/**
 * Converts a given integer value to a string representation of a px value
 *
 * @param num - A number to be converted into a px string
 * @returns A pixel string representation of the number
 */ export var px = function(num) {
    return "".concat(num, "px");
};

//# sourceMappingURL=conversions.js.map